const styles = {
  meterDetails: {
    position: 'relative',
    height: { xs: 'calc(100vh - 56px)', sm: 'calc(100vh - 75px)' },
    padding: 2,
    boxSizing: 'border-box',
    backgroundColor: '#f0f0f0',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    gap: 2,
  },

  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },

  pageTitle: {
    fontFamily: 'Source Sans Pro',
    fontWeight: 600,
    fontSize: { xs: '28px', sm: '38px' },
    lineHeight: '100%',
    color: '#5236AB',
  },

  versionHistoryContainer: { textAlign: 'left' },
  versionInfoText: { fontSize: 14, color: '#555' },
  versionLink: {
    fontSize: 14,
    cursor: 'pointer',
    color: '#5236AB',
    fontWeight: 'bold',
    textDecoration: 'none',
    '&:hover': { textDecoration: 'underline' },
  },

  detailsContent: {
    flexGrow: 1,
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridTemplateRows: '95px minmax(0, 1fr)',
    gap: 2,
    minHeight: 0,
    minWidth: 0,
    overflowY: 'auto',
    overflowX: 'hidden',
  },

  tabbedCard: {
    gridColumn: '1 / -1',
    gridRow: '2',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 0,
    boxShadow: 'none',
    minHeight: 0,
    minWidth: 0,
  },

  cardTabsHeader: {
    px: 1,
    pb: 0.5,
    borderBottom: '1px solid #eee',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1,
    flexWrap: 'wrap',
  },

  cardTabsBar: {
    '& .MuiTab-root': {
      textTransform: 'none',
      minHeight: 44,
      color: '#777',
      fontWeight: 600,
      fontSize: 14,
      fontFamily: 'inherit',
    },
    '& .Mui-selected': { color: '#5236AB' },
    '& .MuiTabs-indicator': {
      backgroundColor: '#5236AB',
      height: 3,
      borderRadius: 3,
    },
  },

  headerControls: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    flexWrap: 'wrap',
  },

  tabbedCardBody: {
    p: 1,
    height: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },

  uploadsGrid: {
    display: 'grid',
    gridTemplateColumns: '3fr 1px 9fr',
    gap: 1,
    flex: 1,
    minHeight: 0,
    alignItems: 'stretch',
  },

  uploadsDivider: { width: '1px', backgroundColor: '#eaeaea', height: 'auto' },

  uploadsCalendarBox: {
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    minHeight: 0,
    border: '1px solid #fff',
    height: '100%',
  },

  uploadsTableBox: {
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    minHeight: 0,
    border: '1px solid #fff',
  },

  chartPane: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    gap: 2,
  },
};

export default styles;
